import { TimeLine, css, keyframes } from 'glamor';
import { CSSProperties } from 'react';
import { fromEntries } from './fromEntries';

export type StylePart = string | CSSProperties | Record<string, CSSProperties>;

export const createStyle = (label: string, rule: StylePart) => {
  return typeof rule === 'string' ? rule : String(css({ label, ...rule }));
};

export const createGlobalStyle = (selector: string, style: CSSProperties) => {
  css.global(selector, style);
};

export const createKeyframes = (name: string, timeline: TimeLine) => {
  return keyframes(name, timeline);
};

export const createStyles = <T extends Record<string, StylePart>>(ruleMap: T) => {
  return fromEntries(Object.entries(ruleMap).map(([k, v]) => {
    return [k, createStyle(k, v)];
  })) as { [K in keyof T]: string };
};
